function deferSupport(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { deferSupport(method) }, 50);
    }
}
  deferSupport(function () {

  $('.contact-item a').on('click', function(event){
    var target = $(this.getAttribute('href'));
    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 150
        }, 1000);
    }
});
    $('.mobile-departments').on('change', function(){
      	var target = $($(this).val());
    if( target.length ) {
        $('html, body').stop().animate({
            scrollTop: target.offset().top - 150
        }, 1000);
    }
    })    
    
    
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.style.minHeight = null;
      panel.style.overflow = "hidden";
      $('.faq-list li > button').removeClass('show');
      $('.faq-list-content').hide();
    } else {
      panel.style.minHeight = panel.scrollHeight + "px";
      panel.style.maxHeight = "none";
      panel.style.overflow = "visible";
    }
  });
}
    $('.faq-list li > button').on('click', function(){
    	$('.faq-list-content').hide();
      	if($(this).hasClass('show')){
          	$(this).removeClass('show');
         	$(this).next().hide();
         }
      else{
        $('.faq-list li > button').removeClass('show');
        $(this).addClass('show');
    	$(this).next().show();
        if($(window).width() < 768){
        	var target = $(this);
    		if( target.length ) {
        	$('html, body').stop().animate({
            	scrollTop: target.offset().top - 150
        	}, 50);
    		}
        }
        
      }
    });
    var timerDone = false;
    setTimeout(function(){ timerDone = true }, 4000);
    $('.supportHubForm').on('submit', function(e) {
        e.preventDefault();
      var error = false;
      var jump = '';
      $('input.required',this).each(function(){
        if($(this).val() == ""){
          error = true;
          if(jump == ''){
          	jump = $(this);
          }
          var label = $(this).siblings('label');
          label.css('color', '#e62817');
          $('span', label).css('color', '#e62817');
        }
        else{
        var label2 = $(this).siblings('label');
          label2.css('color', '#495361');
          $('span', label2).css('color', '#6d7782');	
        }
      });
      var group;
      $('input.required-check', this).each(function(){
        var newGroup = $(this).attr('name');
        if(newGroup != group){
        	group = newGroup;
          if($('input[name="'+group+'"]:checked').length == 0){
          	error = true;
            if(jump == ''){
          		jump = $(this);
          	}
            var label = $(this).siblings('label');
          	label.css('color', '#e62817');
         	 $('span', label).css('color', '#e62817');
          }
          else{
          	var label2 = $(this).siblings('label');
          	label2.css('color', '#495361');
          	$('span', label2).css('color', '#6d7782');
          }
         }
      });
      if(error){
      	$('html, body').animate({
            scrollTop: $(jump).offset().top -300
        },500);
      }
      else{
       $(this).addClass('sending');
        var formData = new FormData(this);
        var theForm = $(this);            
        if(timerDone){
          var newUrl = $(this).attr('action').replace(/sendhooks/g, 'hooks');
          newUrl = newUrl.replace('catches', 'catch');
       $.ajax({
          type: $(this).attr('method'),
          url: newUrl,
          data: formData,
          complete: function (xhr,status) {
            theForm.addClass('successForm').removeClass('sending');
            var target = theForm;
            if( target.length ) {
                $('html, body').stop().animate({
                    scrollTop: target.offset().top - 150
                }, 50);
            }
            
          },
            cache: false,
        contentType: false,
        processData: false
      });
        }else{
         theForm.addClass('successForm').removeClass('sending');
            var target = theForm;
            if( target.length ) {
                $('html, body').stop().animate({
                    scrollTop: target.offset().top - 150
                }, 50);
            }
        
        }
      }
      
      
    });
  
  });